import { MutationTree } from 'vuex';
import { AppState } from '../types';

export const appMutations: MutationTree<AppState> = {

  clear(state) {
    state.title = 'CS Frontend';
  },

  updateTitle(state, payload?: string) {
    state.title = payload || 'CS Frontend';
  },

};
